module.exports = new __parcel__URL__("barn-abandoned-farm-homestead.a8755b47.jpg").toString();